/* airostyle v3 interactions — vanilla JS */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var money = function (cents) { return '$' + (cents / 100).toFixed(2); };

  /* ---------- overlay helpers ---------- */
  var overlay = $('[data-overlay]');
  function lockScroll(on) { document.body.style.overflow = on ? 'hidden' : ''; }
  function showOverlay(on) { if (overlay) overlay.classList.toggle('show', !!on); }

  /* ---------- mobile menu ---------- */
  var menu = $('[data-mobile-menu]');
  function setMenu(open) {
    if (!menu) return;
    menu.classList.toggle('open', open);
    showOverlay(open); lockScroll(open);
  }
  $$('[data-menu-open]').forEach(function (b) { b.addEventListener('click', function () { setMenu(true); }); });
  $$('[data-menu-close]').forEach(function (b) { b.addEventListener('click', function () { setMenu(false); }); });

  /* ---------- search bar ---------- */
  var searchBar = $('[data-search-bar]');
  function setSearch(open) {
    if (!searchBar) return;
    searchBar.classList.toggle('open', open);
    if (open) { var i = searchBar.querySelector('input'); if (i) i.focus(); }
  }
  $$('[data-search-open]').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); setMenu(false); setSearch(!searchBar.classList.contains('open')); });
  });
  $$('[data-search-close]').forEach(function (b) { b.addEventListener('click', function () { setSearch(false); }); });

  /* ---------- header shadow + back to top ---------- */
  var header = $('[data-header]');
  var toTop = $('[data-back-to-top]');
  function onScroll() {
    var y = window.scrollY || window.pageYOffset;
    if (header) header.classList.toggle('is-scrolled', y > 10);
    if (toTop) toTop.classList.toggle('show', y > 600);
    var sticky = $('[data-sticky-atc]');
    if (sticky) {
      var form = $('[data-product-form]');
      var past = form ? (y > form.getBoundingClientRect().top + y - 200) : false;
      var nearBottom = (window.innerHeight + y) > (document.body.scrollHeight - 500);
      sticky.classList.toggle('show', past && !nearBottom);
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
  if (toTop) toTop.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  if (overlay) overlay.addEventListener('click', function () { setMenu(false); setCart(false); });

  /* ---------- cart drawer ---------- */
  var drawer = $('[data-cart-drawer]');
  var shipThreshold = 7500; // cents; mirrors settings.free_shipping_threshold
  function setCart(open) {
    if (!drawer) return;
    drawer.classList.toggle('open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    showOverlay(open); lockScroll(open);
    if (open) renderCart();
  }
  $$('[data-cart-open]').forEach(function (b) { b.addEventListener('click', function () { setMenu(false); setCart(true); }); });
  $$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', function () { setCart(false); }); });

  function renderCart() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var wrap = $('[data-cart-drawer-items]');
      var countEls = $$('[data-cart-count]').concat($$('[data-cart-drawer-count]'));
      countEls.forEach(function (el) { el.textContent = cart.item_count; });
      var sub = $('[data-cart-drawer-subtotal]');
      if (sub) sub.textContent = money(cart.total_price);
      // free shipping bar
      var msg = $('[data-ship-msg]'), fill = $('[data-ship-fill]');
      if (msg && fill) {
        if (cart.total_price >= shipThreshold) {
          msg.textContent = 'You unlocked free shipping.';
          fill.style.width = '100%';
        } else {
          var away = money(shipThreshold - cart.total_price);
          msg.textContent = 'You are ' + away + ' away from free shipping.';
          fill.style.width = Math.min(100, (cart.total_price / shipThreshold) * 100) + '%';
        }
      }
      if (!wrap) return;
      if (!cart.items.length) {
        wrap.innerHTML = '<p class="cart-drawer__empty">Your bag is empty.</p>';
        return;
      }
      wrap.innerHTML = cart.items.map(function (it) {
        return '<div class="cart-item" data-key="' + it.key + '">' +
          '<img src="' + it.image + '" alt="">' +
          '<div class="cart-item__info"><span class="cart-item__title">' + it.product_title + '</span>' +
          '<p class="text-muted">' + (it.variant_title || '') + '</p>' +
          '<div class="cart-item__row"><label class="qty qty--small">' +
          '<button type="button" data-dec aria-label="Decrease">−</button>' +
          '<input type="number" value="' + it.quantity + '" min="0" data-qty>' +
          '<button type="button" data-inc aria-label="Increase">+</button></label>' +
          '<button class="link link--muted" data-remove>Remove</button></div></div>' +
          '<p class="cart-item__price">' + money(it.final_line_price) + '</p></div>';
      }).join('');
      $$('[data-inc]', wrap).forEach(function (b) {
        b.addEventListener('click', function () { changeQty(b, 1); });
      });
      $$('[data-dec]', wrap).forEach(function (b) {
        b.addEventListener('click', function () { changeQty(b, -1); });
      });
      $$('[data-remove]', wrap).forEach(function (b) {
        b.addEventListener('click', function () {
          var key = b.closest('.cart-item').getAttribute('data-key');
          updateCart(key, 0);
        });
      });
      $$('[data-qty]', wrap).forEach(function (inp) {
        inp.addEventListener('change', function () {
          var key = inp.closest('.cart-item').getAttribute('data-key');
          updateCart(key, Math.max(0, parseInt(inp.value, 10) || 0));
        });
      });
    });
  }
  function changeQty(btn, delta) {
    var row = btn.closest('.cart-item');
    var key = row.getAttribute('data-key');
    var inp = row.querySelector('[data-qty]');
    updateCart(key, Math.max(0, (parseInt(inp.value, 10) || 0) + delta));
  }
  function updateCart(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function () { renderCart(); });
  }
  function addToCart(id, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty || 1 })
    }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); });
  }

  /* ---------- quick add ---------- */
  $$('[data-quick-add]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      btn.disabled = true;
      addToCart(btn.getAttribute('data-quick-add'), 1).then(function () {
        setCart(true);
      }).catch(function () {
        window.location.href = btn.closest('.product-card').querySelector('a').href;
      }).then(function () { btn.disabled = false; });
    });
  });

  /* ---------- product gallery with color filtering ---------- */
  function galleryImages(gal) { return $$('[data-gallery-image]', gal); }
  function galleryThumbs(gal) { return $$('[data-gallery-thumb]', gal); }
  function activateGalleryImage(gal, img) {
    var idx = img.getAttribute('data-gallery-image');
    galleryImages(gal).forEach(function (im) { im.classList.toggle('is-active', im === img); });
    galleryThumbs(gal).forEach(function (th) { th.classList.toggle('is-active', th.getAttribute('data-gallery-thumb') === idx); });
  }
  function filterGalleryByColor(gal, color) {
    var c = (color || '').toLowerCase().trim();
    var imgs = galleryImages(gal);
    var thumbs = galleryThumbs(gal);
    var isMatch = function (el) { return (el.getAttribute('data-color') || '').toLowerCase().trim() === c; };
    var anyMatch = !!c && imgs.some(isMatch);
    imgs.forEach(function (im) { im.style.display = (!c || !anyMatch || isMatch(im)) ? '' : 'none'; });
    thumbs.forEach(function (th) { th.style.display = (!c || !anyMatch || isMatch(th)) ? '' : 'none'; });
    var visible = imgs.filter(function (im) { return im.style.display !== 'none'; });
    if (visible.length) activateGalleryImage(gal, visible[0]);
  }
  $$('[data-gallery]').forEach(function (gal) {
    galleryThumbs(gal).forEach(function (th) {
      th.addEventListener('click', function () {
        var i = th.getAttribute('data-gallery-thumb');
        var img = galleryImages(gal).filter(function (im) { return im.getAttribute('data-gallery-image') === i; })[0];
        if (img) activateGalleryImage(gal, img);
      });
    });
  });

  /* ---------- product form: variants, qty, ATC ---------- */
  var form = $('[data-product-form]');
  if (form) {
    var jsonEl = $('[data-product-json]');
    var product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    var variantInput = form.querySelector('[data-variant-id]');
    var atc = form.querySelector('[data-atc]');
    var atcLabel = form.querySelector('[data-atc-label]');
    var stickyBtn = $('[data-sticky-atc-btn]');
    var stickyPrice = $('[data-sticky-price]');
    var gal = $('[data-gallery]');
    var colorIdx = -1;
    if (product && product.options) {
      for (var oi = 0; oi < product.options.length; oi++) {
        if (/^colou?r$/i.test(product.options[oi])) { colorIdx = oi; break; }
      }
    }

    function currentSelections() {
      return $$('[data-option-field]', form).map(function (fs) {
        var sel = fs.querySelector('[data-option-value].is-active');
        return sel ? sel.getAttribute('data-option-value') : null;
      });
    }
    function findVariant() {
      if (!product) return null;
      var sel = currentSelections();
      return product.variants.filter(function (v) {
        return v.options.every(function (opt, i) { return sel[i] === null || opt === sel[i]; });
      })[0] || null;
    }
    function refreshVariant() {
      var v = findVariant();
      if (!v) return;
      variantInput.value = v.id;
      $$('[data-option-field]', form).forEach(function (fs, i) {
        var lab = fs.querySelector('[data-option-selected]');
        if (lab) lab.textContent = v.options[i];
      });
      var priceWrap = $('[data-price]');
      if (priceWrap) {
        var sale = v.compare_at_price && v.compare_at_price > v.price;
        priceWrap.innerHTML = '<div class="price' + (sale ? ' price--sale' : '') + '"><span class="price__current">' + money(v.price) + '</span>' +
          (sale ? '<s class="price__compare">' + money(v.compare_at_price) + '</s>' : '') + '</div>';
      }
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      var avail = v.available;
      atc.disabled = !avail;
      if (atcLabel) atcLabel.textContent = avail ? atcLabel.getAttribute('data-label-add') || 'Add to bag' : 'Sold out';
      if (gal && colorIdx >= 0) filterGalleryByColor(gal, v.options[colorIdx]);
    }
    if (atcLabel && !atcLabel.getAttribute('data-label-add')) {
      atcLabel.setAttribute('data-label-add', atcLabel.textContent.trim());
    }
    $$('[data-option-value]', form).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var fs = btn.closest('[data-option-field]');
        $$('[data-option-value]', fs).forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        refreshVariant();
      });
    });
    // qty stepper
    var qtyInput = form.querySelector('[data-qty-input]');
    $$('[data-qty-minus]', form).forEach(function (b) {
      b.addEventListener('click', function () { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1); });
    });
    $$('[data-qty-plus]', form).forEach(function (b) {
      b.addEventListener('click', function () { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; });
    });
    // ajax add to cart
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      atc.disabled = true;
      addToCart(variantInput.value, parseInt(qtyInput.value, 10) || 1)
        .then(function () { setCart(true); })
        .catch(function () { form.submit(); })
        .then(function () { atc.disabled = false; });
    });
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        atc.click();
      });
    }
    refreshVariant();
  }

  /* ---------- testimonial slider ---------- */
  $$('[data-slider]').forEach(function (slider) {
    var track = slider.querySelector('.slider__track');
    var slides = $$('.slider__slide', slider);
    var dotsWrap = slider.querySelector('[data-slider-dots]');
    var idx = 0, timer = null;
    slides.forEach(function (_, i) {
      var d = document.createElement('button');
      d.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      d.addEventListener('click', function () { go(i); restart(); });
      dotsWrap.appendChild(d);
    });
    var dots = Array.prototype.slice.call(dotsWrap.children);
    function go(i) {
      idx = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (idx * 100) + '%)';
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === idx); });
    }
    function restart() { if (timer) clearInterval(timer); timer = setInterval(function () { go(idx + 1); }, 6000); }
    go(0); restart();
  });

  /* ---------- carousel buttons ---------- */
  $$('[data-carousel]').forEach(function (car) {
    var track = car.querySelector('.carousel__track');
    var prev = car.querySelector('[data-carousel-prev]');
    var next = car.querySelector('[data-carousel-next]');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -320, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: 320, behavior: 'smooth' }); });
  });

  /* ---------- collection sort ---------- */
  var sortSel = $('[data-sort]');
  if (sortSel) {
    sortSel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSel.value);
      window.location.href = url.toString();
    });
  }

  /* ---------- reveal on scroll ---------- */
  var revealEls = $$('.section, .product-card');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { threshold: 0.08 });
    revealEls.forEach(function (el) { el.classList.add('reveal'); io.observe(el); });
  }
})();
